import { useNavigate } from 'react-router-dom';
import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';
import icon from '../../assets/img/logo_trans.png';

function AuthNavbar() {
    const navigate = useNavigate();

    return (
        <Navbar expand="lg" className="bg-body-tertiary">
            <Container>
                <Navbar.Brand onClick={() => navigate('/')} style={{ cursor: 'pointer' }} className="d-flex align-items-center">
                    <img
                        src={icon}
                        alt="Logo"
                        className="d-inline-block align-top"
                        style={{ maxHeight: '50px', width: 'auto' }}
                    /> Radšej To Nahraj
                </Navbar.Brand>
            </Container>
        </Navbar>
    );
}

export default AuthNavbar;
